import React, { useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Contact() {
  const { t } = useLanguage();
  const [mapLoaded, setMapLoaded] = useState(false);

  return (
    <section id="contact" data-testid="contact-section" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2
            data-testid="contact-title"
            className="font-heading text-3xl lg:text-4xl font-semibold tracking-tight mb-4"
            style={{ color: "#0A0A0A" }}
          >
            {t("contact.title")}
          </h2>
          <div className="w-16 h-0.5 mx-auto mb-4" style={{ backgroundColor: "#D4AF37" }} />
          <p className="text-base text-neutral-500">{t("contact.subtitle")}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            <div className="flex items-start gap-4" data-testid="contact-phone">
              <div
                className="w-12 h-12 flex items-center justify-center rounded-full shrink-0"
                style={{ backgroundColor: "#8B0000" }}
              >
                <Phone className="h-5 w-5 text-white" />
              </div>
              <div>
                <h3 className="font-heading font-semibold text-lg mb-1" style={{ color: "#0A0A0A" }}>
                  {t("contact.phone")}
                </h3>
                <a
                  href="tel:+491798272922"
                  className="text-base text-neutral-600 hover:text-[#8B0000] transition-colors"
                >
                  +49 179 827 2922
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4" data-testid="contact-address">
              <div
                className="w-12 h-12 flex items-center justify-center rounded-full shrink-0"
                style={{ backgroundColor: "#8B0000" }}
              >
                <MapPin className="h-5 w-5 text-white" />
              </div>
              <div>
                <h3 className="font-heading font-semibold text-lg mb-1" style={{ color: "#0A0A0A" }}>
                  {t("contact.address")}
                </h3>
                <p className="text-base text-neutral-600">
                  {t("contact.addressValue")}
                </p>
                <p className="text-sm font-semibold mt-1 leading-relaxed" style={{ color: "#3A3A3A" }}>
                  ({t("contact.shopInfo")})
                </p>
              </div>
            </div>
          </div>

          {/* Map with click-to-load (DSGVO compliance) */}
          <div data-testid="contact-map">
            <h3 className="font-heading font-semibold text-lg mb-4" style={{ color: "#0A0A0A" }}>
              {t("contact.findUs")}
            </h3>
            <div className="w-full h-80 bg-neutral-100 rounded-sm border border-neutral-200 overflow-hidden">
              {!mapLoaded ? (
                <div className="w-full h-full flex items-center justify-center p-6">
                  <div className="text-center max-w-sm">
                    <MapPin className="h-10 w-10 mx-auto mb-3" style={{ color: "#8B0000" }} />
                    <h4 className="font-heading font-semibold text-base mb-2" style={{ color: "#0A0A0A" }}>
                      {t("contact.mapLoadTitle")}
                    </h4>
                    <p className="text-xs text-neutral-600 mb-4 leading-relaxed">
                      {t("contact.mapLoadNotice")}
                    </p>
                    <button
                      onClick={() => setMapLoaded(true)}
                      className="text-sm font-semibold px-5 py-2 rounded-sm text-white transition-opacity hover:opacity-80"
                      style={{ backgroundColor: "#8B0000" }}
                    >
                      {t("contact.mapLoadButton")}
                    </button>
                  </div>
                </div>
              ) : (
                <iframe
                  title="Al-Kasbah Location"
                  src="https://www.openstreetmap.org/export/embed.html?bbox=11.9640%2C51.4795%2C11.9740%2C51.4855&layer=mapnik&marker=51.4825%2C11.9690"
                  className="w-full h-full border-0"
                  loading="lazy"
                  allowFullScreen
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}